import styles from '../ProductActivityPage.module.css'
import type { RuleLine } from './model'

// The server's rule lines, printed as they come: the drawer's "Why this cycle"
// and the Processing rules worked example (h 2740-2742) both use this, so the
// two read the same.
export function RuleLineList({ lines, label }: { lines: RuleLine[]; label?: string }) {
  return (
    <div aria-label={label} role={label ? 'list' : undefined}>
      {lines.map((l, i) => (
        <div key={i} className={styles.ruleRow} role={label ? 'listitem' : undefined} data-rule={l.key}>
          <span className={l.ok ? styles.markOk : styles.markNo}>{l.ok ? '✓' : '—'}</span>
          <div className={styles.tlMain}>
            <div className={styles.ruleText}>{l.text}</div>
            <div className={styles.ruleRule}>Rule: {l.rule}</div>
          </div>
        </div>
      ))}
    </div>
  )
}
